import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=734a4774&scoped=true"
import script from "./help-center.vue?vue&type=script&lang=js"
export * from "./help-center.vue?vue&type=script&lang=js"
import style0 from "./help-center.vue?vue&type=style&index=0&id=734a4774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734a4774",
  null
  
)

export default component.exports